export const CART_TYPE = {
  CART: 'cart',
  BOX: 'winebox'
};

export const SECTIONS_NAME = {
  IN_STOCK: 'inStock',
  PRE_ARRIVAL: 'prearrival',
  PRIMEUR: 'primeur'
};

export const SECTIONS_VALUE = {
  IN_STOCK_USA: '1',
  PRE_ARRIVAL: '2',
  PRIMEUR_USA: '3',
  IN_STOCK_NOT_USA: 'L',
  PRIMEUR_NOT_USA: 'P',
};

export const SECTIONS = [
  { valueId: SECTIONS_VALUE.IN_STOCK_NOT_USA, name: SECTIONS_NAME.IN_STOCK },
  { valueId: SECTIONS_VALUE.PRIMEUR_NOT_USA, name: SECTIONS_NAME.PRIMEUR },
  { valueId: SECTIONS_VALUE.IN_STOCK_USA, name: SECTIONS_NAME.IN_STOCK },
  { valueId: SECTIONS_VALUE.PRIMEUR_USA, name: SECTIONS_NAME.PRIMEUR },
  { valueId: SECTIONS_VALUE.PRE_ARRIVAL, name: SECTIONS_NAME.PRE_ARRIVAL }
];

export const PRIMEUR = {
  US: '3', COMMON: 'P'
};

export const WINEBOX_MAX = 6;
export const PRODUCT_QTY_MAX = 50;
